import { render, staticRenderFns } from "./ImportSettings.vue?vue&type=template&id=a08c7012&"
import script from "./ImportSettings.vue?vue&type=script&lang=js&"
export * from "./ImportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports